module.exports = function $_type(name) {
  return {
    $_type: name,
  };
};
